import _regenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _objectSpread from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _asyncToGenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.flat.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.unscopables.flat.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { DualAxes } from "@antv/g2plot";
import chartMixin from "../mixin/chartMixin";
import dayjs from "dayjs";
export default {
  name: "FraudSessionsChart",
  mixins: [chartMixin],
  data: function data() {
    return {
      chart: null,
      dateTime: [dayjs().subtract(1, "month").format("YYYY-MM-DD"), dayjs().subtract(1, "day").format("YYYY-MM-DD")]
    };
  },
  mounted: function mounted() {
    this.init();
  },
  methods: {
    getData: function getData() {
      var _arguments = arguments,
        _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var other, type, param, queryApi;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              other = _arguments.length > 0 && _arguments[0] !== undefined ? _arguments[0] : {};
              type = _arguments.length > 1 ? _arguments[1] : undefined;
              param = {
                grain: _this.communityGrain,
                start: _this.dateTime[0],
                end: _this.dateTime[1],
                groupBy: '',
                created: 'conversation_time'
              }; // getPostChartDataByDistinct
              queryApi = "getPostChartData";
              return _context.a(2, new Promise(function (resolve, reject) {
                _this.$api[queryApi](_objectSpread(_objectSpread({}, param), other)).then(function (res) {
                  var data = res.data.map(function (i) {
                    return _objectSpread(_objectSpread({}, i), {}, {
                      category: type,
                      value: i.fraud_conversation_count || i.distinct_other_cnt || i.fraud_user_count || 0
                    });
                  });
                  resolve(data);
                }).catch(function (err) {
                  reject([]);
                });
              }));
          }
        }, _callee);
      }))();
    },
    getPostChartData: function getPostChartData() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              return _context2.a(2, Promise.all([_this2.getData({
                chartName: "ads_fraud_target_users_chart",
                valueName: "fraud_user_count"
              }, "诈骗用户数"), _this2.getData({
                chartName: "ads_fraud_target_users_chart",
                valueName: "distinct_other_cnt"
              }, "受影响用户数")]).then(function (res) {
                if (res.length) {
                  return res.flat(2);
                }
                return [];
              }));
          }
        }, _callee2);
      }))();
    },
    init: function init() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var lineData, barData;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              _this3.loading = true;
              //fraud_conversation_count 诈骗会话数
              _context3.n = 1;
              return _this3.getPostChartData();
            case 1:
              lineData = _context3.v;
              _context3.n = 2;
              return _this3.getData({
                chartName: "ads_fraud_target_users_chart",
                valueName: "fraud_conversation_count"
              }, "诈骗会话数");
            case 2:
              barData = _context3.v;
              _this3.loading = false;
              if (!_this3.chart) {
                _context3.n = 3;
                break;
              }
              _this3.chart.changeData([barData, lineData]);
              _this3.restoreLegendSelection();
              return _context3.a(2);
            case 3:
              _this3.chart = new DualAxes('fraud-sessions', {
                data: [barData, lineData],
                xField: 'time',
                yField: ['value', 'value'],
                geometryOptions: [{
                  geometry: 'column',
                  seriesField: 'category',
                  color: '#598af9'
                }, {
                  geometry: 'line',
                  seriesField: 'category',
                  smooth: true,
                  color: function color(_ref) {
                    var category = _ref.category;
                    if (category === '诈骗用户数') return '#f5b516';
                    if (category === '受影响用户数') return '#50d39c';
                    return '#f5b516';
                  }
                }],
                legend: {
                  position: "top",
                  offsetY: 70
                },
                appendPadding: [70, 0, 0, 0]
              });
              _this3.chart.render();
              _this3.bindLegendSync();
            case 4:
              return _context3.a(2);
          }
        }, _callee3);
      }))();
    },
    command: function command(type) {
      this.communityGrain = type;
      this.init();
    }
  }
};